import JSEncrypt from 'jsencrypt'

const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCJ4jlJRj64VDPhQN+A1k7/K8AZQ+uGYpBMjxA1+VjxX0a/p4Q71uFPwmbqYkANJEOCbzJQAlTPnXVAqMOxo/CyXzT8ryD7RBf/HgHdIohdKxT2aqvaIMtGICPjQLU/ziqYRrOuJi2HruniQ8hFhyAn4JMTk0xVJsDQUcKGfXwEkQIDAQAB'
//JSEncrypt实例
let encryptor = new JSEncrypt();
encryptor.setPublicKey(publicKey);

export default encryptor;
